<template lang="pug">
    v-card
        model-data-table(
            loading-text="Cargando documentos con deuda..."
            no-data-text="Sin documentos con deuda."
            no-search
            no-remove
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action( 
                    color='dark'
                    tooltip='PDF'
                    @click='submitPdf(props)' 
                )
                    v-icon picture_as_pdf
        detail-dialog(ref="invoiceReceivableDialog" :invoiceId="invoiceId" readOnly)
</template>

<script>
//-
import { RBtnAction, ModelDataTable } from '@/components/reusable_components/next'
import SlSaleInvoiceMdl from '@/models/Sale/SlSaleInvoice.js'
import TableHeaders from '@/views/customer/tables/customerReceivableInvoice/Headers.js'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'

export default {
    name: 'customer-receivable-invoice',
    props: {},
    data: function() {
        return {
            serviceTable: {
                dtFetchData: () => {},
            },
            headerTable: TableHeaders,
            customerId: null,
            invoiceId: null,
        }
    },
    computed: {
        tableProps() {
            return {
                service: SlSaleInvoiceMdl,
                paramFilter: {
                    sl_customer_id: this.customerId,
                    receivable: 1,
                },
                headers: this.headerTable,
                filters: [
                    {
                        name: 'number',
                        type: 'text-field',
                        props: {
                            label: 'Folio',
                        },
                        flex: {
                            sm6: true,
                            lg5: true,
                        },
                    },
                ],
            }
        },
    },
    methods: {
        /**
         */
        setCustomerId() {
            this.customerId = this.$route.params.id
        },

        /**
         * @description
         * Print sale invoice PDF
         *
         * @param      {object}  event   The event
         * @return     {object}  blob file
         */
        submitPdf(event) {
            return event.item.toPdf()
        },

        /**
         *
         */
        submitShow(event) {
            this.invoiceId = event.item.id
            this.$refs.invoiceReceivableDialog.open = true
        },
    },
    watch: {},
    components: {
        RBtnAction,
        'model-data-table': ModelDataTable,
        'detail-dialog': DetailDialog,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setCustomerId()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
